module.exports = __webpack_public_path__ + "static/media/boy-cooking.7f1f560d.png";